// extracted by mini-css-extract-plugin
export var desc = "index-module--desc--SoE0n";
export var titleWrapper = "index-module--titleWrapper--VBBGe";